/** Coerces a data-bound value (typically a string) to a number. */
export function coerceNumberProperty(value: any, fallbackValue: number = 0) {
  return (!Array.isArray(value) && (value - parseFloat(value) + 1) >= 0) ? Number(value) : fallbackValue;
}
